/**
 * CSS custom property names + defaults every component in this package reads from,
 * rather than hardcoding colors. `ThemeProvider` (`ThemeProvider.tsx`) sets these on a
 * wrapping element from a tenant's `TenantBranding` record (system_architecture.md
 * §11.1) — but every component works correctly with *no* `ThemeProvider` at all, falling
 * back to these defaults via CSS `var(--token, fallback)`, so a consuming app can render
 * components before branding data has loaded (or in Storybook/tests) without a flash of
 * unstyled content.
 */
export const THEME_TOKENS = {
    colorPrimary: "--sl-color-primary",
    colorSecondary: "--sl-color-secondary",
    colorAccent: "--sl-color-accent",
};
/** Sensible platform defaults — used both as the CSS `var()` fallback value baked into
 * every component's stylesheet, and as `ThemeProvider`'s own defaults when a tenant
 * hasn't set a branding color yet (`TenantBranding.primary_color` etc. are all
 * nullable). */
export const DEFAULT_THEME = {
    primaryColor: "#1a73e8",
    secondaryColor: "#334155",
    accentColor: "#f97316",
};
/** Fixed, non-brandable tokens: the "Tomato Vendor" stock traffic-light colors
 * (system_architecture.md §5 — green/orange/red is a universal, desaturation-friendly
 * signal that must stay legible regardless of tenant branding, so it is deliberately
 * NOT themeable the way primary/secondary/accent are) and touch-target sizing (§4/§5:
 * large, tactile, no complex nested dropdowns). */
export const FIXED_TOKENS = {
    colorStockOk: "#15803d",
    colorStockLow: "#c2703d",
    colorStockDepleted: "#b91c1c",
    /** Minimum touch-target edge length in px — WCAG 2.5.5 AAA / Apple HIG guidance,
     * chosen deliberately large for a till used by a standing, possibly gloved, possibly
     * rushed operator. */
    touchTargetMin: 56,
};
//# sourceMappingURL=tokens.js.map